import Breadcrumbs from '@pelckmans/elementis/components/breadcrumbs';
import Page from '@pelckmans/elementis/components/page';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import ContentBody from '../../../layout/content/ContentBody';
import ContentHeader from '../../../layout/content/ContentHeader';
import AggregatedModuleAlerts from '../../../shared-components/alerts/AggregatedModuleAlerts';
import { withScrollThreshold } from '../../../shared-components/elementis/hoc/withScrollThreshold';
import ModuleContext from '../_contexts/ModuleContext';
import SuperModuleBreadcrumb from '../components/breadcrumbs/SuperModuleBreadcrumb';
import { SearchResult } from './api/search-api';
import AdvancedSearchField from './components/AdvancedSearchField';
import SearchResultList from './components/SearchResultList';

function Search() {
  const [searchResults, setSearchResults] = React.useState<SearchResult>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { t } = useTranslation();
  const { allModules } = useContext(ModuleContext);

  useDocumentTitle(t('PAGES.SEARCH.DOCUMENT_TITLE'));

  const selectedModules = useMemo(() => {
    if (!searchResults?.length) return [];
    const ids = new Set(searchResults.map(r => r.moduleId));

    return allModules.filter(m => ids.has(m.id));
  }, [searchResults, allModules]);

  return (
    <>
      <ContentHeader
        cover={
          <Page.Header
            headerText={t('PAGES.SEARCH.HEADER.TITLE')}
            breadcrumbs={
              <Breadcrumbs aria-label={t('MODULE_BREADCRUMB.A11Y_LABEL')}>
                <SuperModuleBreadcrumb />
              </Breadcrumbs>
            }
            extra={<AdvancedSearchField setSearchResults={setSearchResults} setIsLoading={setIsLoading} />}
          />
        }
      />
      <ContentBody alerts={<AggregatedModuleAlerts selectedModules={selectedModules} />}>
        <SearchResultList results={searchResults} isLoading={isLoading} />
      </ContentBody>
    </>
  );
}

export default withScrollThreshold(Search);
